import Link from 'next/link'
import { TransparentButton, SecondaryButton } from 'common/button'
import { Typography } from 'common/typography'
import Wrapper from 'common/wrapper'
import { BiHomeAlt } from 'react-icons/bi'
import { FiBarChart } from 'react-icons/fi'
import styled from 'styled-components'
import useSession from 'querys/session'
import { useSubscriptionPlans, useSubscriptionStatus } from 'querys/subscriptions'
import DiscountTimer from 'common/banner/discount-timer'
import { MdOutlineGridView } from 'react-icons/md'
import { useRouter } from 'next/router'

const LearningPlanFixedElementsStyled = styled.div`
  position: fixed;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 2;
  .navigation-mobile {
    background: var(--neutral100);
  }
  .navigation-mobile-container {
    display: flex;
  }
  .nm-btn {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-block-start: 1rem;
    padding-block-end: 1rem;
    color: var(--neutral40);
    &.active {
      color: var(--white);
    }
  }
  .pricing-banner {
    background: #FFF627;
    padding-block: .5rem;
    color: var(--neutral100);
  }
  .pricing-banner-container {
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
  }
  .original-price {
    margin-inline-start: .25rem;
    text-decoration: line-through;
  }
  .discount-container {
    display: flex;
    gap: 0.5rem;
    align-items: center;
  }
  .countdown-container {
    margin-block-end: .5rem;
  }
  @media(min-width: 768px) {
    .discount-container {
      align-items: initial;
      flex-direction: column;
      gap: 0;
    }
    .countdown-container {
      margin-block-end: 0;
    }
    .cta-container {
      display: flex;
      align-items: center;c
      justify-content: space-between;
    }
  }
  @media(min-width: 1024px) {
    .pricing-banner {
      padding-block: 1rem;
    }
    .pricing-banner-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: space-between;
    }
    .navigation-mobile {
      display: none;
    }
  }
`

const NavigationSpacer = styled.div`
  block-size: 4.75rem;
  @media(min-width: 1024px) {
      display: none;
  }
  `

const BannerSpacer = styled.div`
  block-size: 7.25rem;
  @media(min-width: 1024px) {
      display: none;
  }
`

function LearningPlanFixedElements({ course, selected, setSelected }) {
  const { token } = useSession()
  const { asPath } = useRouter()
  const { data } = useSubscriptionPlans()
  const { data: access } = useSubscriptionStatus({ product: 'ALL' })

  const { year: { price, original_price, discount } } = data || { year: {} }

  const isProjectsPlan = asPath === '/aprender/proyectos'
  const isPlan = asPath === '/aprender'
  const isStats = asPath === '/aprender#stats'

  return (
    <>
      <LearningPlanFixedElementsStyled>
        <div className="navigation-mobile">
          <Wrapper>
            <div className="navigation-mobile-container">
              <Link
                href="/aprender" id="plan-btn"
                className={`nm-btn ${isPlan ? 'active' : ''}`}
              >
                <BiHomeAlt size={24} color="inherit" />
                <Typography as="span" font="smallBold">Plan de estudios</Typography>
              </Link>
              <Link
                href="/aprender/proyectos" id="plan-btn"
                className={`nm-btn ${isProjectsPlan ? 'active' : ''}`}
              >
                <MdOutlineGridView size={24} color="inherit" />
                <Typography as="span" font="smallBold">Proyectos</Typography>
              </Link>
              {token ? (
                <Link href="/aprender#stats" replace id="progress-btn"
                  className={`nm-btn ${isStats ? 'active' : ''}`}
                >
                  <FiBarChart size={24} color="inherit" />
                  <Typography as="span" font="smallBold">Estadísticas</Typography>
                </Link>
              ) : null}
            </div>
          </Wrapper>
        </div>
        {!access.is_active ? (
          <div className="pricing-banner">
            <Wrapper>
              <div className="pricing-banner-container">
                <div>
                  <Typography font="p2Bold">
                    {course?.title || 'Inicia sin saber nada y crea tu portafolio'}
                  </Typography>
                  <Typography small="regularBold" large="headline5" color="var(--secondary)">
                  $
                    {price?.amount}
                    {price?.currency_code}
                    {discount?.status === 'VALID' ? (
                      <Typography className="original-price" as="span" font="p2Regular" color="#5F0088">
                      $
                        {original_price?.amount}
                        {original_price?.currency_code}
                      </Typography>
                  ) : null}
                  </Typography>
                </div>
                <div>
                  <div className="cta-container">
                    <div className="countdown-container">
                      <DiscountTimer
                        color="inherit"
                        caption="La oferta termina en:"
                        discount={discount}
                      />
                    </div>
                    <Link href="/comprar/anual" passHref>
                      <SecondaryButton fullWidth fitContent>
                      Suscribirme
                      </SecondaryButton>
                    </Link>
                  </div>
                </div>
              </div>
            </Wrapper>
          </div>
        ) : null}
      </LearningPlanFixedElementsStyled>
      <NavigationSpacer />
      {!access.is_active ? (
        <BannerSpacer />
      ) : null}
    </>
  )
}

export default LearningPlanFixedElements
